import { createFileRoute } from "@tanstack/react-router"

import { ReportsPage } from "@/reports/components/reports-page"

export const Route = createFileRoute("/_app-shell/reports")({
  head: () => ({ meta: [{ title: "Reports - Kestly" }] }),
  component: () => <ReportsPage />,
})
